import { render, staticRenderFns } from "./AppHeaderWithMenu.vue?vue&type=template&id=01dbd74d&"
import script from "./AppHeaderWithMenu.vue?vue&type=script&lang=js&"
export * from "./AppHeaderWithMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports